import React from 'react';
import styled from 'styled-components';
import { colors, spaces, typography } from '../../../lib/styles';
import Minus2 from '../../Icon/components/Minus2';
import Plus2 from '../../Icon/components/Plus2';
import BaseAccordionItem, { AccordionItemValue } from './BaseAccordionItem';
import { ControlsIcon } from './ControlsIcon';

const Wrapper = styled.div<{ isFirst: boolean; isLast: boolean; isOpen: boolean }>`
    color: ${colors.typography.root};
    border-color: ${colors.typography.contentBorder};
    border-style: solid;
    border-top-width: ${({ isFirst }) => (isFirst ? 0 : `1px`)};
    border-bottom-width: ${({ isLast }) => (isLast ? `1px` : 0)};
    border-left-width: 0;
    border-right-width: 0;
    padding-left: ${spaces.space7}px;
    padding-right: ${spaces.space7}px;
    padding-bottom: ${({ isOpen }) => (isOpen ? `${spaces.space7}px` : 0)};
`;

const Title = styled.p`
    margin: 0;
    font-weight: ${typography.fontWeights.bold};
`;

interface Props {
    id: string;
    title: string;
    children: React.ReactNode;
    isOpen?: boolean;
    isLast?: boolean;
    isFirst?: boolean;
    onOpen?: (accordionItemValue: AccordionItemValue) => void;
    onClick?: () => void;
}

export const AccordionItem = ({
    title,
    isOpen = false,
    isFirst = false,
    isLast = false,
    ...props
}: Props) => (
    <Wrapper data-testid="accordion-item" isOpen={isOpen} isLast={isLast} isFirst={isFirst}>
        <BaseAccordionItem
            {...props}
            title={title}
            isOpen={isOpen}
            triggerContent={
                <>
                    <Title>{title}</Title>
                    <ControlsIcon isOpen={isOpen} color={colors.grey500}>
                        {isOpen ? <Minus2 /> : <Plus2 />}
                    </ControlsIcon>
                </>
            }
        />
    </Wrapper>
);
